import React from 'react';
import linkifyHtml from 'linkifyjs/html';
import { ReactTinyLink } from "react-tiny-link";


const ImageMessage = (props) => {

  return <div className="sc-message--text">
    {props.message.includes('/Param') &&<span style={{cursor:"pointer"}} className="text-primary" dangerouslySetInnerHTML={{ __html: linkifyHtml(props.message) }}>
                        </span>
                      }
    {((props.message.includes('<p>http')||props.message.includes('<p><a href=')) && !props.message.includes('localhost'))&&<ReactTinyLink
        cardSize="small"
        showGraphic={true}
        maxLine={2}
        minLine={2}
        url={props.message.replace( /(<([^>]+)>)/ig, '')}
      />
    }

    {!props.message.includes('/Param') &&<span className={props.authorType === "received" ?  "codespan" : "text-dark"} dangerouslySetInnerHTML={{ __html: linkifyHtml(props.message) }}>
                      </span>
    }
    </div>

};

export default ImageMessage;
